export class InboxApplicationKey {
  public static readonly AppealsGrievances = 'AppealsGrievances';
  public static readonly PSCCR = 'PSCCR';
  public static readonly PACWellpointTXCommercial = 'PACWellpointTXCommercial';

  public static readonly InboxesWithoutTenant = [
    this.AppealsGrievances,
    this.PSCCR,
  ];
}
